/* @HEADER
 * @version 1.0.1618 | 2026-09-20
 * @purpose The two hash overlays that draw over the authenticated route without changing it — the personal cabinet (#account) and the organization settings (#organization, legacy #workspace-settings) — decided from the hash as data, so App.tsx no longer holds three startsWith flags (ZVX-DEV-6136, App.tsx-by-meaning S3).
 * @sidecar hashOverlay.ts.header.md
 * @layer app | @hex domain | @ctx app
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-6136, ZVX-DEV-2616, ZVX-DEV-1454

export type HashOverlay = 'account' | 'workspace-settings'

export const CANONICAL_WORKSPACE_SETTINGS_HASH = '#organization'
/** ZVX-DEV-2616 — old bookmarks; recognised, and rewritten to the canonical hash by the host. */
export const LEGACY_WORKSPACE_SETTINGS_HASH = '#workspace-settings'

/**
 * Prefix-matched on purpose: the overlays own everything under their hash
 * (`#organization/members`, `#account?tab=…`), exactly as the three
 * `startsWith` reads in App.tsx did. `parseRouteFromHash` returns the
 * default route for these hashes, so the route below stays put while the
 * overlay renders (ZVX-DEV-1454).
 */
export function resolveHashOverlay(hash: string | null | undefined): HashOverlay | null {
  const h = typeof hash === 'string' ? hash : ''
  if (h.startsWith('#account')) return 'account'
  if (h.startsWith(CANONICAL_WORKSPACE_SETTINGS_HASH) || h.startsWith(LEGACY_WORKSPACE_SETTINGS_HASH)) return 'workspace-settings'
  return null
}

/** Whether the address bar still says the legacy hash and should converge on the canonical one. */
export function isLegacyWorkspaceSettingsHash(hash: string | null | undefined): boolean {
  return typeof hash === 'string' && hash.startsWith(LEGACY_WORKSPACE_SETTINGS_HASH)
}
